import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What are you proud of?",
  "description": "",
  "published": "2011-10-13T00:00:00.000Z",
  "redirect_from": ["/blog/what-are-you-proud-of/swizec/2620"],
  "categories": "Fred Wilson, Humor, Interview, jQuery, Mind map, Question, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/300px-Power_Horse_Energy_Drink3.jpg",
        "alt": "Dose Power Horse Energy Drink",
        "title": "Dose Power Horse Energy Drink"
      }}></img></p>
    <p>{`Lately I've been looking for work of the python and javascript programming variety - turns out getting caffeine, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Energy_drink",
        "title": "Energy drink"
      }}>{`energy drinks`}</a>{` and food is difficult without money. And since it doesn't seem people are looking for programming `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Freelancer",
        "title": "Freelancer"
      }}>{`freelancers`}</a>{` these days, or I suck at finding such offers, I end up being interviewed a lot.`}</p>
    <p>{`A good interview with a team you know is pretty cool can actually be quite enjoyable.`}</p>
    <p>{`But a particular question really sticks out as a sore point for me. It shows up in interviews without fail, hell, I've asked it almost every single time I ever interviewed someone.`}</p>
    <p><em parentName="p">{`What are you proud of?`}</em></p>
    <p>{`It looks like an innocent question. A friendly opportunity to let you talk about something cool`}</p>
    <p>{`I used to `}<em parentName="p">{`love`}</em>{` answering this question. It could get me talking for hours ... well, 30 minutes at least ... there was always something I could tout my own horn with.`}</p>
    <p>{`But then, projects started piling up, I no longer had a single thing I was proud of. Nothing I did seemed like a colossal success anymore. Not like when I was just starting out working on my own projects, back then I was proud of every little turd I squeezed out of my arse.`}</p>
    <p>{`Nowadays it doesn't feel like any project I've done really sticks out as something to be horribly proud of. Certainly not enough to pop to mind off the cup in the heat of the moment. I have to weigh my answer, pick one of perhaps ten or even twenty projects ... or god knows how many more I should be proud of but have gone out of my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Working_memory",
        "title": "Working memory"
      }}>{`immediate memory`}</a>{`.`}</p>
    <p>{`Furthermore, the question feels a bit lazy.`}</p>
    <p>{`I always send my github profile together with every first contact mail for coding work. And my blog. If you spent even ten minutes preparing to talk to me, you could ask about a specific project that seemed interesting to you. They're all out there somewhere anyway.`}</p>
    <p>{`Hell, you could just order my github profile by follower/fork count and ask me about whatever comes up on top. Chances are it's a project I will enjoy talking about since it's popular and it grounds the discussion. My option space is much narrower and thus easier to define.`}</p>
    <p>{`More importantly, when you ask me about a specific project, you've shown an interest in one of many fields of my work. I know what `}<em parentName="p">{`you`}</em>{` will find interesting.`}</p>
    <p>{`Otherwise I might as well start explaining how proud I am of that one `}<a parentName="p" {...{
        "href": "http://jquery.com/",
        "title": "JQuery"
      }}>{`jQuery library`}</a>{` for buttons I made a couple of years ago, where you're actually more interested in me because you know I once got Readibility to run on a server and scraped about a million web articles in horribly little time.`}</p>
    <p>{`But what do I know, maybe it's just that ever since I've heard of the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Dunning%E2%80%93Kruger_effect",
        "title": "Dunning–Kruger effect"
      }}>{`Dunning-Krueger effect`}</a>{` everything I've ever created feels a bit bland and unexciting since I can't decide if it actually `}<em parentName="p">{`is`}</em>{` technically exciting or not. Or maybe I've just gotten to know too many awesome people and I feel a bit uninteresting in comparison.`}</p>
    <p>{`Anyway here are ten things I'm proud of in no particular order to help me answering such questions in the future:`}</p>
    <ol>
      <li parentName="ol">{`My `}<a parentName="li" {...{
          "href": "http://swizec.com/code/styledButton/"
        }}>{`jQuery buttons plugin`}</a>{` is 5th hit on google for "jquery buttons" 2 years after being made`}</li>
      <li parentName="ol">{`I nearly got a startup in cahoots with VC's`}</li>
      <li parentName="ol">{`At one point I made the first instagram node.js library`}</li>
      <li parentName="ol">{`Ran Readability on a server to scrape articles back before it was cool`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/doing-a-startup-taught-me-the-value-of-staying-in-school/swizec/1819",
          "title": "Doing a startup taught me the value of staying in school"
        }}>{`My best academic year was also my best entreprenurial year`}</a></li>
      <li parentName="ol">{`I have a blog that gets about 15k visitors a month`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://www.avc.com/",
          "title": "Fred Wilson"
        }}>{`Fred Wilson`}</a><a parentName="li" {...{
          "href": "http://www.avc.com/a_vc/2010/09/ping.html"
        }}>{` once referenced me by name in his blog`}</a></li>
      <li parentName="ol">{`I'm 23 and I have more than 6 years of professional dev experience`}</li>
      <li parentName="ol">{`I have never screwed up college so hard I'd have to cheat to get all the legal student perks`}</li>
      <li parentName="ol">{`I used to spend 2+ hours a day doing stupid stuff with a bike and never broke a bone ... I did almost kill my balls though`}</li>
    </ol>
    <p>{`Is it just me? Do others find it easier to talk about what they're proud of?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://diablotintelevision.wordpress.com/2011/09/06/i-love-me-proud-of-me-proud-of-us/"
        }}>{`I LOVE ME , Proud of ME, Proud of US!!!`}</a>{` (diablotintelevision.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/2011/10/prweb8856078.htm"
        }}>{`Breathe Life into Web-pages with Packt's New jQuery Book and eBook`}</a>{` (prweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ksl.com?nid=148&sid=16958094&s_cid=rss-148"
        }}>{`Five questions to ask during a job interview`}</a>{` ()`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.reddit.com/r/coding/comments/ksq7m/first_programming_job_what_did_you_learn_on_the/"
        }}>{`What you learnt on job, that you didn't learn in school`}</a>{` (reddit.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.mt-soft.com.ar/2011/10/12/seven-premium-style-jquery-plugins-and-tutorials-to-display-images-on-websites/"
        }}>{`Seven Premium Style jQuery Plugins And Tutorials To Display Images On Websites`}</a>{` (mt-soft.com.ar)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7de9171c-aa1f-48a7-a3c7-1deb4f49d342",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      